var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInformationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.6431 9.99833C17.6431 5.50115 13.9975 1.85547 9.50028 1.85547C5.0031 1.85547 1.35742 5.50115 1.35742 9.99833C1.35742 14.4955 5.0031 18.1412 9.50028 18.1412C13.9975 18.1412 17.6431 14.4955 17.6431 9.99833ZM16.5574 9.99833C16.5574 13.8959 13.3978 17.0555 9.50028 17.0555C5.60273 17.0555 2.44314 13.8959 2.44314 9.99833C2.44314 6.10077 5.60273 2.94118 9.50028 2.94118C13.3978 2.94118 16.5574 6.10077 16.5574 9.99833ZM8.95742 5.79118V6.74118C8.95742 7.04099 9.20047 7.28404 9.50028 7.28404C9.80009 7.28404 10.0431 7.04099 10.0431 6.74118V5.79118C10.0431 5.49137 9.80009 5.24833 9.50028 5.24833C9.20047 5.24833 8.95742 5.49137 8.95742 5.79118ZM8.95742 8.50547V14.2055C8.95742 14.5053 9.20047 14.7483 9.50028 14.7483C9.80009 14.7483 10.0431 14.5053 10.0431 14.2055V8.50547C10.0431 8.20566 9.80009 7.96261 9.50028 7.96261C9.20047 7.96261 8.95742 8.20566 8.95742 8.50547Z",
    fill: "#005FC8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInformationIcon);
export default __webpack_public_path__ + "static/media/information-icon.95da9d8e.svg";
export { ForwardRef as ReactComponent };